import React from 'react';
import { ModalType } from 'global/utils/ModalsHelper';
import ActionModal from '@insurancemenu/imenu-components-lib/dist/components/modals/ActionModal';
import { ActionModalProps } from '@insurancemenu/imenu-components-lib/dist/types/ActionModal';
import { GroupNameStyled } from './styles';
import { REMOVE_GROUP_WARNING_MODAL } from '../constants';

interface Props
  extends Omit<
    ActionModalProps,
    'title' | 'subtitle' | 'actionButtonText' | 'modalType' | 'closeButtonText' | 'data-test-id'
  > {
  groupName: string;
}

const RemoveGroupModal: React.FC<Props> = ({ groupName, ...rest }) => {
  return (
    <ActionModal
      title="Attention (IM users only function)"
      subtitle={
        <>
          You are about to remove <GroupNameStyled>{groupName}</GroupNameStyled> group. This is a hard delete from all
          services. The only way to restore this group is to create it from scratch.
        </>
      }
      closeButtonText="Cancel"
      actionButtonText="Remove"
      modalType={ModalType.DELETE}
      data-test-id={REMOVE_GROUP_WARNING_MODAL}
      {...rest}
    />
  );
};

export default RemoveGroupModal;
